module.exports = __webpack_public_path__ + "img/lens-167-minus-01.0df8eb9c.png";